export const interBuyerInfoSchema = {
  notifierType: "",
  phoneNumber: "",
  email: "",
  receiverPhoneNumber: "",
  receiverEmail: ""
};

export const passengerSchema = {
  firstName: "",
  lastName: "",
  gender: "",
  nationality: "IR",
  nationalId: "",
  passportNumber: "",
  passportIssuePlace: "",
  passportExpirationDate: "",
  id: "",
  birthdate: ""
};

export const DEFAULT_PASSENGER_COUNT = 1;
